<!--  <div class="title">Open Alarms <span id="AlarmCount" class="counter">{{ alarmCount }}</span></div>-->
<div id="AlarmList">
  <app-loader [isLoading]="isLoading"></app-loader>
  @if (alarms.length === 0 && !isLoading && canReadAlarms) {
    <div class="noData">No Data</div>
  }
  @if (alarms.length === 0 && !isLoading && !canReadAlarms) {
    <div class="noData">No Permissions</div>
  }
  @if (alarms.length > 0 && !isLoading) {
    <div id="AlarmContainer">
      @for (alarm of alarms; track trackById($index, alarm)) {
        <div
          (click)="viewAlarm(alarm)"
          class="alarmItem"
          style="cursor: pointer"
          >
          <div [ngClass]="'sev' + alarm.severity" class="sev"></div>
          <div class="cut" title="{{ alarm.description }}">{{ alarm.code }}</div>
          <div class="alarmDate" title="{{ formatTime(alarm.timestamp) }}">
            {{ formatTime(alarm.timestamp) }}
          </div>
        </div>
      }
    </div>
  }
</div>
